var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndMedicalDeviceIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ind_medical_device_icn",
    transform: "translate(-167 -430)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(167 430)",
    fill: "none",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_diagram_850141",
    transform: "translate(166.5 425.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3988",
    "data-name": "Path 3988",
    d: "M91.006,30.9a.871.871,0,0,0-.607.28.794.794,0,0,0-1.4.513.82.82,0,0,0,.3.63h0l1.1.863,1.073-.863h0a.786.786,0,0,0-.467-1.423Z",
    transform: "translate(-58.682 -10.121)",
    fill: "#05b239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3989",
    "data-name": "Path 3989",
    d: "M45.563,36.676H41.325a.7.7,0,0,0-.605.35l-1.281,2.333L39.066,32.9a.672.672,0,0,0-.536-.63.736.736,0,0,0-.768.35L35.5,36.7H31.5a.7.7,0,0,0,0,1.4h4.4a.7.7,0,0,0,.605-.35l1.281-2.333.373,6.462a.672.672,0,0,0,.536.63.345.345,0,0,0,.163.023.7.7,0,0,0,.605-.35L41.721,38.1H45.54a.687.687,0,0,0,.7-.7A.7.7,0,0,0,45.563,36.676Z",
    transform: "translate(-14.031 -11.113)",
    fill: "#05b239"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 0.933,
    cy: 0.933,
    r: 0.933,
    transform: "translate(30.16 35.571)",
    fill: "#05b239"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 0.933,
    cy: 0.933,
    r: 0.933,
    transform: "translate(16.764 35.571)",
    fill: "#05b239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    "data-name": "Path 3990",
    d: "M12.5,21.249v14.9A3.546,3.546,0,0,0,16.018,39.7H32.982A3.546,3.546,0,0,0,36.5,36.151v-14.9A3.546,3.546,0,0,0,32.982,17.7H16.018A3.546,3.546,0,0,0,12.5,21.249Zm1.4,0a2.137,2.137,0,0,1,2.12-2.139H32.982a2.137,2.137,0,0,1,2.12,2.139V33.283H13.9Zm0,13.444H32.772v1.457a2.137,2.137,0,0,1-2.12,2.139H16.018a2.137,2.137,0,0,1-2.12-2.139Z",
    transform: "translate(0 0)",
    fill: "#05b239"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndMedicalDeviceIcn);
export default __webpack_public_path__ + "static/media/ind_medical_device_icn.3d533206790e9852cbc0657c5bbe2b2c.svg";
export { ForwardRef as ReactComponent };